import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    my: {
        stories: [],
        next: ''
    },
    new: {
        stories: [],
        next: ''
    },
    best: {
        stories: [],
        next: ''
    },
    tabsUpdated: 0,
    pageSize: 10,
    errors: {}
};

getters['fetchMy'] = function(state) { return state.my.stories };
getters['fetchMyNext'] = function(state) { return state.my.next };
getters['fetchNew'] = function(state) { return state.new.stories };
getters['fetchNewNext'] = function(state) { return state.new.next };
getters['fetchBest'] = function(state) { return state.best.stories };
getters['fetchBestNext'] = function(state) { return state.best.next };
getters['fetchTabsUpdated'] = function(state) { return state.tabsUpdated };

const actions = {
    get(context, payload) {
        return ApiService
            .get('stories/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_STORIES', [payload, response.data.results]);
                context.commit('SET_NEXT', [payload, response.data]);
                context.commit('SET_PAGE_SIZE', response.data.page_size);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
    getNext(context, payload) {
        return ApiService
            .get(context.state[payload].next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_STORIES', [payload, response.data.results]);
                context.commit('SET_NEXT', [payload, response.data]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    vote(context, payload) {
        return ApiService
            .get('stories/' + payload.id + payload.url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTE', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    create(context, payload) {
        return ApiService
            .post('stories/create/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_STORY', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    update(context, payload) {
        return ApiService
            .put('stories/' + payload.id + '/update/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('UPDATE_STORY', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    remove(context, payload) {
        return ApiService
            .delete('stories/' + payload + '/remove/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_STORY', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    updateTabs(context, payload) {
        context.commit('SET_TABS_UPDATED');
    }
}

const mutations = {
    SET_STORIES(state, [type, stories]) {
        state[type].stories = stories;
        state.errors = {};
    },
    ADD_STORIES(state, [type, stories]) {
        state[type].stories = state[type].stories.concat(stories);
        state.errors = {};
    },
    ADD_STORY(state, story) {
        if (state.my.stories.length > state.pageSize) {
            state.my.stories.pop();
        }
        if (state.new.stories.length > state.pageSize) {
            state.new.stories.pop();
        }
        state.my.stories.unshift(story);
        state.new.stories.unshift(story);
        state.tabsUpdated++;
    },
    UPDATE_STORY(state, story) {
        let types = ['my', 'new', 'best']
        for (let i = 0; i < types.length; i++) {
            for (let j in state[types[i]].stories) {
                if (state[types[i]].stories[j].id == story.id) {
                    state[types[i]].stories[j].title = story.title;
                    state[types[i]].stories[j].text = story.text;
                }
            }
        }
    },
    REMOVE_STORY(state, story) {
        let types = ['my', 'new', 'best']
        for (let i = 0; i < types.length; i++) {
            for (let j in state[types[i]].stories) {
                if (state[types[i]].stories[j].id == story) {
                    state[types[i]].stories.splice(j, 1);
                }
            }
        }
    },
    SET_NEXT(state, [type, data]) {
        if (data.page < data.num_pages) {
            state[type].next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state[type].next = '';
        }
        state.errors = {};
    },
    SET_VOTE(state, vote) {
        let types = ['new', 'best']
        for (let i = 0; i < types.length; i++) {
            for (let j in state[types[i]].stories) {
                if (state[types[i]].stories[j].id == vote.id) {
                    state[types[i]].stories[j].liked = vote.liked;
                    state[types[i]].stories[j].disliked = vote.disliked;
                    state[types[i]].stories[j].rating = vote.likes - vote.dislikes;
                }
            }
        }

    },
    SET_TABS_UPDATED(state, tabsUpdated) {
        state.tabsUpdated++;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.pageSize = pageSize;
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
